export default __webpack_public_path__ + "static/media/close-circle-fill.177525b4.svg";